import { Injectable, inject } from '@angular/core';
import { Firestore } from '@angular/fire/firestore';
import { collection, addDoc, doc, updateDoc, onSnapshot } from 'firebase/firestore';
import { Observable, BehaviorSubject } from 'rxjs';
import { Brand } from '../models/brand.model';

@Injectable({
  providedIn: 'root'
})
export class BrandService {
  private firestore = inject(Firestore);
  private collectionName = 'brands';
  

  private selectedBrandSubject = new BehaviorSubject<Brand | null>(null);
  public selectedBrand$ = this.selectedBrandSubject.asObservable();

  setSelectedBrand(brand: Brand | null) {
    if (brand?.id) {
      localStorage.setItem('selected_brand_id', brand.id);
    }
    this.selectedBrandSubject.next(brand);
  }

  getSelectedBrandIdFromStorage(): string | null {
    return localStorage.getItem('selected_brand_id');
  }

  getBrands(): Observable<Brand[]> {
    const col = collection(this.firestore, this.collectionName);
    return new Observable<Brand[]>(observer => {
      return onSnapshot(col, (snapshot) => {
        const brands = snapshot.docs
          .map(doc => ({ id: doc.id, ...doc.data() } as Brand))
          .filter(b => !b.isDeleted)
          .sort((a, b) => a.name.localeCompare(b.name));
        observer.next(brands);
      }, observer.error);
    });
  }

  addBrand(brand: Brand) {
    const col = collection(this.firestore, this.collectionName);
    return addDoc(col, { ...brand, createdAt: new Date() });
  }

  updateBrand(id: string, data: Partial<Brand>) {
    const docRef = doc(this.firestore, this.collectionName, id);
    return updateDoc(docRef, { ...data, updatedAt: new Date() });
  }

  deleteBrand(id: string) {
    const docRef = doc(this.firestore, this.collectionName, id);
    return updateDoc(docRef, { isDeleted: true, updatedAt: new Date() });
  }
}